// 马可波罗海外版配置

/**
 * BASE_API 接口域名
 * BASE_MICRO_APPS 微前端子应用域名
 */
const config = {
  local: {
    APP_ID: 1000040,
    BASE_API: '//powergo-api-test-eu.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-test-eu.nioint.com'
  },
  dev: {
    APP_ID: 1000040,
    BASE_API: '//powergo-api-dev-eu.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-dev-eu.nioint.com'
  },
  test: {
    APP_ID: 1000040,
    BASE_API: '//powergo-api-test-eu.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-test-eu.nioint.com'
  },
  stg: {
    APP_ID: 1000040,
    BASE_API: 'powergo-api-stg-eu.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-stg-eu.nioint.com'
  },
  prod: {
    APP_ID: 1000040,
    BASE_API: 'powergo-api-eu.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-eu.nioint.com'
  }
}

module.exports = config
